module.exports = __webpack_public_path__ + "assets/img/202112-3W.dd742773.png";